module.exports = __webpack_public_path__ + "static/media/c9aa3955.jpg";